import "./BakeryDetailsModal.css";

import {
  MdClose,
  MdCake,
  MdCategory,
  MdCurrencyRupee,
  MdSchedule,
  MdInventory,
  MdVerified,
  MdStar,
} from "react-icons/md";

import getImageUrl from "../../../../../../utils/imageUrl";

function BakeryDetailsModal({
  isOpen,
  product,
  onClose,
}) {
  if (!isOpen || !product) return null;

  const image = product.image
    ? getImageUrl(product.image)
    : "/images/no-image.png";

  return (
    <div className="bakery-details-overlay">

      <div className="bakery-details-modal">

        <button
          className="close-btn"
          onClick={onClose}
        >
          <MdClose />
        </button>

        <div className="details-header">

          <img
            src={image}
            alt={product.productName || "Bakery product"}
            onError={(event) => {
              event.currentTarget.src =
                "/images/no-image.png";
            }}
          />

          <div className="header-content">

            <h2>{product.productName}</h2>

            <span className="category-badge">
              {product.category}
            </span>

            <div className="price-section">

              <span className="offer-price">
                ₹{product.offerPrice}
              </span>

              <span className="actual-price">
                ₹{product.price}
              </span>

            </div>

          </div>

        </div>

        <div className="details-grid">

          <div className="detail-card">
            <MdCake />
            <div>
              <h4>Flavour</h4>
              <p>{product.flavour}</p>
            </div>
          </div>

          <div className="detail-card">
            <MdCategory />
            <div>
              <h4>Egg Type</h4>
              <p>{product.eggType}</p>
            </div>
          </div>

          <div className="detail-card">
            <MdInventory />
            <div>
              <h4>Weight</h4>
              <p>{product.weight}</p>
            </div>
          </div>

          <div className="detail-card">
            <MdSchedule />
            <div>
              <h4>Preparation</h4>
              <p>{product.preparationTime}</p>
            </div>
          </div>

          <div className="detail-card">
            <MdCurrencyRupee />
            <div>
              <h4>Stock</h4>
              <p>{product.stock}</p>
            </div>
          </div>

          <div className="detail-card">
            <MdVerified />
            <div>
              <h4>Status</h4>
              <p>{product.stockStatus}</p>
            </div>
          </div>

        </div>

        <div className="badges">

          {product.availableToday && (
            <span className="badge green">
              Available Today
            </span>
          )}

          {product.isAvailable && (
            <span className="badge blue">
              In Stock
            </span>
          )}

          {product.customCake && (
            <span className="badge purple">
              Custom Cake
            </span>
          )}

          {product.advanceOrder && (
            <span className="badge orange">
              Advance Order
            </span>
          )}

          {product.isBestSeller && (
            <span className="badge yellow">
              <MdStar />
              Best Seller
            </span>
          )}

        </div>

        <div className="description-box">

          <h3>Description</h3>

          <p>
            {product.description ||
              "No description available."}
          </p>

        </div>

      </div>

    </div>
  );
}

export default BakeryDetailsModal;